import { render, staticRenderFns } from "./Resiko.vue?vue&type=template&id=df17722e&scoped=true&"
import script from "./Resiko.vue?vue&type=script&lang=js&"
export * from "./Resiko.vue?vue&type=script&lang=js&"
import style0 from "./Resiko.vue?vue&type=style&index=0&id=df17722e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df17722e",
  null
  
)

export default component.exports